module.exports = __webpack_public_path__ + "static/img/21001B_2_3_R_20210906_LC.45ea078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/21001B_2_3_R_20210906_LC.png
// module id = TmMq
// module chunks = 0